import React from 'react';
import { LocationInfo } from '../types';

interface Props {
    locations: LocationInfo[];
    menuName: string;
}

const Location: React.FC<Props> = ({
    locations,
    menuName,
}) => {
    return (
        <div className="location">
            <a href="https://kyobohealthcare.aimmed.com/">HOME</a>
            {
                locations? (
                    locations.map(location => (
                        <a key={location.title} href={location.url}>{location.title}</a>
                    ))
                ): (
                    <a></a>
                )
            }
            <span>{menuName}</span>
            <button type="button" title="메뉴열기">메뉴 열기</button>
        </div>
    )
}

export default Location;